module.exports = __webpack_public_path__ + "static/Homepage-adc66c963c9bb3f0ebc329ccdaa1d318.jpg";